import useApiQuery from 'shared/hooks/use-api-query';
import citiesKeys from '../util/cities-keys';
import {NeighborhoodProps} from 'modules/neighborhoods/types';

const useCityNeighborhoods = (cityId: string) => {
  return useApiQuery<NeighborhoodProps[]>({
    url: `/neighborhoods/cities/${cityId}`,
    queryKey: citiesKeys.neighborhoods(cityId),
  });
};

export default useCityNeighborhoods;
